/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PasswordChangeDto } from '../../models/password-change-dto';
import { User } from '../../models/user';

export interface ChangeUserPassword$Params {
  pwChange: PasswordChangeDto;
  user: User;
}

export function changeUserPassword(http: HttpClient, rootUrl: string, params: ChangeUserPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, changeUserPassword.PATH, 'post');
  if (params) {
    rb.query('pwChange', params.pwChange, {});
    rb.query('user', params.user, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

changeUserPassword.PATH = '/v1/user/changeUserPassword';
